"use client"

import { motion, useReducedMotion } from "framer-motion"

const easeOut = [0.22, 1, 0.36, 1] as const

const editorialBlocks = [
  {
    headline: "Host with care.",
    body: "One composed page for your gathering — details, location, and context in one place.",
  },
  {
    headline: "Know who's with you.",
    body: "Guests see what matters. No threads. No fragmentation.",
  },
  {
    headline: "Keep what was shared.",
    body: "The page persists. Photos and moments become part of a living timeline.",
  },
] as const
const rhythmClassByIndex = [
  "py-30 sm:py-38",
  "py-20 sm:py-26",
  "py-36 sm:py-44",
] as const
const copyWidthByIndex = ["max-w-[44ch]", "max-w-[38ch]", "max-w-[46ch]"] as const

export function MarketingCalmHosting() {
  const reduceMotion = useReducedMotion()

  return (
    <section className="relative w-full min-w-0">
      <div className="w-full min-w-0 border-y border-border/30">
        {editorialBlocks.map((block, i) => {
          const alignRight = i % 2 === 1

          return (
            <motion.article
              key={block.headline}
              className={`border-b border-border/30 ${rhythmClassByIndex[i % rhythmClassByIndex.length]} ${
                i === 1 ? "bg-card/[0.16]" : "bg-transparent"
              } last:border-b-0`}
              initial={reduceMotion ? false : { opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: reduceMotion ? 0 : 0.65,
                delay: reduceMotion ? 0 : i * 0.04,
                ease: easeOut,
              }}
            >
              <div className="mx-auto grid max-w-[72rem] px-6 sm:px-8">
                <div className={alignRight ? "sm:col-start-6 sm:col-end-13" : "sm:col-start-1 sm:col-end-8"}>
                  <h2
                    className={`type-display-title ${
                      i === 1 ? "max-w-[20ch] text-[clamp(2.05rem,4.2vw,3.45rem)]" : "max-w-[22ch]"
                    } text-balance tracking-tight !mb-0`}
                  >
                    {block.headline}
                  </h2>
                  <p
                    className={`type-hero-subtitle ${i === 1 ? "mt-4" : "mt-6 sm:mt-7"} ${
                      copyWidthByIndex[i % copyWidthByIndex.length]
                    } text-pretty text-foreground/82`}
                  >
                    {block.body}
                  </p>
                </div>
              </div>
            </motion.article>
          )
        })}
      </div>
    </section>
  )
}
